import fileNameSanitizer from "helpers/sanitizers";
import { FILEPICKER_API_KEY } from "./constants";

export const filestackEndpoints = (imageWidth, fit, Blob) => {
  const storeEndpoint = "https://process.filestackapi.com";
  return `${storeEndpoint}/${FILEPICKER_API_KEY}/${Blob.url}`;
};

export const sanitizeUrl = (url) => fileNameSanitizer(url);
